import { TechStackFields } from './interface';

export const techStackInitialValues: TechStackFields = {
  techsGroupsOpt: [],
};
